"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.materialColors = exports.colors = exports.reds = exports.greys = exports.yellows = exports.blues = void 0;
exports.blues = [
    { color: '#3e5b73', name: 'primary-dark-blue' },
    { color: '#486a86' },
    { color: '#527A9A' },
    { color: '#5d89AD', name: 'primary-blue' },
    { color: '#6798c0' },
    { color: '#76a2c6' },
    { color: '#85adcd' },
    { color: '#a4c1d9' },
    { color: '#d1e0ec' },
    { color: '#f0f5f9' },
];
exports.yellows = [
    { color: '#988238' },
    { color: '#b19741' },
    { color: '#caad4a' },
    { color: '#e4c254' },
    { color: '#fdd85d', name: 'primary-yellow' },
    { color: '#fde07d' },
    { color: '#fee89e' },
    { color: '#feecae' },
    { color: '#fef3ce' },
    { color: '#fffbef' },
];
exports.greys = [
    { color: '#000000' },
    { color: '#1b242d', name: 'primary-black' },
    { color: '#323a42' },
    { color: '#495057' },
    { color: '#8b9196' },
    { color: '#a8adb0' },
    { color: '#b7bbbe' },
    { color: '#c5c8cb', name: 'primary-grey' },
    { color: '#e2e3e5' },
    { color: '#ffffff', name: 'primary-white' },
];
exports.reds = [
    { color: '#4a161a' },
    { color: '#6f2026' },
    { color: '#942b33' },
    { color: '#b93640' },
    { color: '#c04a53', name: 'primary-red' },
    { color: '#ce7279' },
    { color: '#dc9ba0' },
    { color: '#eac3c6' },
    { color: '#f1d7d9' },
    { color: '#f8ebec' },
];
exports.colors = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], exports.blues, true), exports.yellows, true), exports.greys, true), exports.reds, true);
var reduceToMaterialColorMap = function (colorArr) {
    return colorArr.reverse().reduce(function (acc, _a, index) {
        var _b;
        var color = _a.color;
        var key = index === 0 ? 50 : index * 100;
        return __assign(__assign({}, acc), (_b = {}, _b[key] = color, _b));
    }, {});
};
exports.materialColors = {
    blue: reduceToMaterialColorMap(exports.blues),
    yellow: reduceToMaterialColorMap(exports.yellows),
    grey: reduceToMaterialColorMap(exports.greys),
    red: reduceToMaterialColorMap(exports.reds),
};
